import {Component, ViewChild, Output, EventEmitter, AfterViewInit} from '@angular/core';
import { AppService } from '@api';
import {RespuestaEstatusEnum} from '@enumeraciones/Enumeraciones.enum';
import { SistemaService } from '@servicios/Sistema.Service';
import { TranslateService } from '@ngx-translate/core';
import { MensajeService } from '@mensaje/Mensaje.Service';
import { Pregunta } from '@modelo/proceso/Pregunta.model';
import { AlertaEnum } from '@mensaje/Enumeraciones/MensajeEnumeraciones.enum';
import { InputComponent } from '@componentes/Input/Input.component';
import { NodeWithI18n } from '@angular/compiler';


@Component({
    selector: 'relacionPregunta',
    templateUrl: './relacionPregunta.component.html',
    styleUrls: ['./relacionPregunta.component.scss']
})
export class RelacionPreguntaComponent implements AfterViewInit {
    @Output() respuesta = new EventEmitter();
    public abierto!: boolean;
    public animacion!: string;
    public entidad: Pregunta;

    cambio: boolean = false;
    relacion: boolean;
    Blockrelacion: boolean = false;
    quitarrelacionados: boolean;
    texto!:string;
    preguntasimportar: any[];
    dataTable!: Array<any>;
    limpiar: boolean = false;

    PreguntasYaSeleccionadas: any[];
    SelCompetencia: any[];
    SelCriterio: any[];
    SelPuesto: any[];
    SelTipoPregunta: any[];
    SelTipoColaborador: any[];
    SelDepartamento: any[];
    SelNivel: any[];
    FiltroPregunta:any[];
    SelEscalaevaluacion: any[] = []

    cargarbusqueda: boolean = false;
    preguntapadre :number = 0
    BlockPreguntaId: boolean = false;
    BlockCompetencia: boolean = false;
    BlockCriterio: boolean = false;
    BlockPuesto: boolean = false;
    BlockTipoPregunta: boolean = false;
    BlockTipoColaborador: boolean = false;
    BlockDepartamento: boolean = false;
    BlockNivel: boolean = false;

    @ViewChild("inputpregunta", { static: false}) input!: InputComponent;

    constructor(private appService: AppService, public sistemaService: SistemaService, public translate: TranslateService, private mensajeService: MensajeService){
        this.entidad = new Pregunta();

        this.PreguntasYaSeleccionadas = []
        this.preguntasimportar = [];

        this.relacion = false;
        this.quitarrelacionados = false;

        this.SelTipoColaborador = [];
        this.SelCompetencia = [];
        this.SelCriterio = [];
        this.SelTipoPregunta = [];
        this.SelDepartamento = [];
        this.SelNivel = [];
        this.SelPuesto = [];
        this.FiltroPregunta = [];
    }


    ngAfterViewInit() {

    }

    //Carga la informacion en modal
    Modal(preguntapadre: number = 0) {
        if(preguntapadre != 0){
            this.preguntapadre = preguntapadre
        }
        this.SetFiltros();
        this.preguntasimportar = [];
        this.animacion = this.sistemaService.animacionAbirModal;
        this.abierto = true;

        setTimeout(() => {
            this.input.LimpiarValor()
        }, 410)
    }

    //Cierra la modal y destruye todos los elementos creados
    CerrarModal() {
        this.animacion = this.sistemaService.animacionCerrarModal;
        this.dataTable = [];
        this.PreguntasYaSeleccionadas = [];
        setTimeout(() => {
          this.abierto = false;
        }, 310);
    }

    //Validaciones para las preguntas relacionadas y las que se pueden relacionar
    SetDatos(datapreguntas: any[]) {
        this.dataTable = datapreguntas;
        if(this.preguntapadre != 0){
            this.dataTable.forEach((element,index)=>{
              if(element.preguntaid == this.preguntapadre){
                  this.dataTable.splice(index, 1)
              }
            })
        }
        if(this.PreguntasYaSeleccionadas.length > 0){
            for(let preguntaid of this.PreguntasYaSeleccionadas){
                let indice = 0
                while(indice < this.dataTable.length){
                    let element = this.dataTable[indice]
                    if(element.preguntaid == preguntaid){
                        this.dataTable.splice(indice,1)
                    }else{
                        indice++;
                    }
                }
            }
        }
    }

    SetEscalaEvaluacion(tipodepreguntaid: number) {
        if (tipodepreguntaid == 1) {
            this.appService.Post("configuracion/escalaevaluacion/buscar", {activo: 1}).then(res => {
                if (res.status == RespuestaEstatusEnum.Success) {
                    this.SelEscalaevaluacion = res.data;
                }
            });
        }
        else if (tipodepreguntaid == 2) {
            this.SelEscalaevaluacion = [];
            this.entidad.escalaevaluacionid = 0;
        }
        else {
            this.SelEscalaevaluacion = [];
        }
    }

    // Guardar las preguntas relacionadas
    Guardar(){
    if (this.preguntasimportar.length == 0) {
      return this.mensajeService.Alerta(AlertaEnum.Warning, "Seleccione uno o más registros");
    }
    this.respuesta.next(this.preguntasimportar)
    }

    //filtrado de busqueda de preguntas
    SetFiltros() {
        this.appService.Get("catalogo/nivel").then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.SelNivel = res.data;
            }
        });
        this.appService.Post("configuracion/competencia/buscar", {activo: 1}).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.SelCompetencia = res.data;
            }
        });
        this.appService.Get("catalogo/tipopregunta").then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.SelTipoPregunta = res.data;
            }
        });
        if(this.cargarbusqueda){
            this.buscar()
        }
    }

    LimpiarFiltros(){
        this.entidad = new Pregunta()
        this.input.LimpiarValor()
    }

    SetCriterio(competenciaid: number) {
            this.appService.Post("configuracion/criterio/buscar", {competenciaid: competenciaid, activo: 1}).then(res => {
                if (res.status == RespuestaEstatusEnum.Success) {
                    this.SelCriterio = res.data;
                }
            });
    }

    // busqueda de preguntas
    buscar(){
        let data = new Pregunta(this.entidad);
        this.appService.Post( "planeacion/pregunta/buscar", data).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                if(this.quitarrelacionados){
                    this.SetDatos(res.data)
                }else{
                    this.dataTable = res.data;
                }
            }
          })


    }
}

